import { vaultPostRequest } from '../helpers';
import type { IRetryUploadResponse } from './retry-upload-response';
import { retryUploadResponseSchema } from './retry-upload-response';

export async function retryUploadApi(jobId: number): Promise<IRetryUploadResponse> {
  return vaultPostRequest({
    path: `/upload/queue/${jobId}/retry`,
    body: {},
    schema: retryUploadResponseSchema,
  });
}
